<mat-sidenav-container class="min-h-[100vh]" autosize>
  <mat-sidenav #sidenav [mode]="'over'">
    <app-sidebar></app-sidebar>
  </mat-sidenav>
  <mat-sidenav-content class="bg-primary min-h-[100vh] !flex flex-col">
    <div class="sprite" [innerHtml]="sanitizer.bypassSecurityTrustHtml((svgSprite$ | async)!)"></div>
    <app-header (toggleSidebar)="sidenav.toggle()"></app-header>
    <div class="flex-1 flex flex-col">
      <router-outlet></router-outlet>
    </div>
    <app-footer></app-footer>
  </mat-sidenav-content>
</mat-sidenav-container>
<app-feedback-button></app-feedback-button>
